export default __webpack_public_path__ + "static/media/bethany_on.e82b39fa.png";